import type { CustomerReferralProgramDiscountRecord } from '@navio/nsdk';
import { formatCurrencyAmount } from 'noddi-util';

export const formatReferralProgramDiscountLabel = (discounts: CustomerReferralProgramDiscountRecord[]): string => {
  if (discounts.length === 0) {
    return '';
  }

  return discounts
    .map((discount) => {
      if (discount.discount?.amount != null && discount.discount.amount > 0) {
        return formatCurrencyAmount({ money: discount.discount, decimals: 0 });
      }
      if (discount.discountPercentage != null) {
        return `${discount.discountPercentage} %`;
      }
      return discount.namePublic;
    })
    .join(', ');
};
